module.exports = __webpack_public_path__ + "static/media/promo_ski.49e91110.png";